export interface ICompletePhone {
  cityCode: string;
  phoneNumber: string;
}

export interface IOtherPhone {
  otherPhone: ICompletePhone;
}

export interface IValidationStatus {
  [key: string]: 'UNCONFIRMED' | 'PENDING' | 'CONFIRMED';
}

export enum ValidationStatusEnum {
  UNCONFIRMED = 'UNCONFIRMED',
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED'
}

export interface ICustomerPhoneWithValidations {
  validations: IValidationStatus[];
  otherPhone?: ICompletePhone;
  mobilePhone?: ICompletePhone;
  allowWhatsAppContact?: boolean;
}
